import { render, staticRenderFns } from "./XImage.vue?vue&type=template&id=ff0fb428&scoped=true"
import script from "./XImage.vue?vue&type=script&lang=js"
export * from "./XImage.vue?vue&type=script&lang=js"
import style0 from "./XImage.vue?vue&type=style&index=0&id=ff0fb428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0fb428",
  null
  
)

export default component.exports